




























import { Component, Vue } from 'vue-property-decorator';

import FlagshipDefineGoalsCardViewModel
  from '@/vue-app/view-models/components/my-investment-dashboard-v2/flagship-define-goals-card-view-model';

@Component({
  name: 'FlagshipDefineGoalsCard',
  components: {},
})
export default class FlagshipDefineGoalsCard extends Vue {
  flagship_define_goals_card_view_model = Vue.observable(new FlagshipDefineGoalsCardViewModel());
}
